import { makeStyles } from '@material-ui/styles';
import { primaryBackgroundColor, primaryFontFamily } from '../constants/StyleConfig';
import { white } from '../constants/Colors';
import siChatBackgroundImg from '../assets/image/paycor_logo_icon.svg';

export default makeStyles((theme) => ({
    '@global': {
        html: {
            margin: '0',
            padding: '0',
            minHeight: 'fill-available',
            WebkitMinHeight: '-webkit-fill-available',
        },
        body: {
            fontFamily: primaryFontFamily,
            fontWeight: '400',
            margin: '0',
            padding: '0',
            background: ({ isWhiteBackground }) => (isWhiteBackground
                ? white
                : (theme?.common?.panel?.backgroundColor || primaryBackgroundColor || '#f6f6f6')),
        },
        iframe: {
            border: 'none !important',
            width: '0 !important',
            height: '0 !important',
        },
        p: {
            margin: '0 0 10px',
            whiteSpace: 'pre-line',
            boxSizing: 'border-box',
        },
        '@media print': {
            body: {
                '-webkit-print-color-adjust': 'exact',
            },
            '@page': {
                margin: '1cm',
            },
        },
        '#root': {
            margin: '0',
            padding: '0',
            position: 'relative',
        },
        '@keyframes menuContentIn': {
            from: {
                opacity: '0',
                transform: 'translate(-40px, 0)',
            },
            to: {
                opacity: '1',
                transform: 'translate(0, 0)',
            },
        },
        '@keyframes samplePreviewIn': {
            from: {
                opacity: '0',
                transform: 'translate(100px, 0)',
            },
            to: {
                opacity: '1',
                transform: 'translate(0, 0)',
            },
        },
        '@keyframes pulse': {
            '0%': {
                opacity: '.5',
            },
            '100%': {
                opacity: '1',
            },
        },
        '@keyframes fade-slide-in': {
            from: {
                opacity: '0',
                transform: 'translateY(-10px)',
            },
            to: {
                opacity: '1',
                transform: 'translateY(0)',
            },
        },
        '@keyframes fade-slide-out': {
            from: {
                opacity: '0',
                transform: 'translateY(10px)',
            },
            to: {
                opacity: '1',
                transform: 'translateY(0)',
            },
        },
        '@keyframes rotate': {
            '100%': {
                transform: 'rotate(360deg)',
            },
        },
        '@keyframes dash': {
            '0%': {
                strokeDasharray: '1px, 200px',
                strokeDashoffset: '0',
            },
            '50%': {
                strokeDasharray: '89px, 200px',
                strokeDashoffset: '-35px',
            },
            '100%': {
                strokeDasharray: '89px, 200px',
                strokeDashoffset: '-124px',
            },
        },
        '@keyframes fade': {
            from: {
                opacity: '1',
            },
            to: {
                opacity: '0',
            },
        },
        '#si_frame': {
            width: '100% !important',
            height: '100% !important',
        },
        '#si-wrapper.si-livechat .silc-btn-button:not(.silc-btn-button-close)':
        {
            backgroundImage: `url(${siChatBackgroundImg}) !important`,
            backgroundSize: '40px !important',
            backgroundColor: `${white} !important`,
        },
    },
    application: {
        maxWidth: '100%',
        marginTop: ({
            canRenderHeader, isMobile, isPublicMode,
        }) => (!canRenderHeader || isMobile || isPublicMode ? '0px' : '74px'),
    },
}));
